function VerticalSpace(props) {

    const {space} = props

    return (
        <div style={{paddingTop: space}}/>
    )

}


export default VerticalSpace